import { render, staticRenderFns } from "./OfficeClient.vue?vue&type=template&id=728f8372&scoped=true"
import script from "./OfficeClient.vue?vue&type=script&lang=js"
export * from "./OfficeClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f8372",
  null
  
)

export default component.exports